import { render, staticRenderFns } from "./NewProspect.vue?vue&type=template&id=1ab58fc8&scoped=true"
import script from "./NewProspect.vue?vue&type=script&lang=js"
export * from "./NewProspect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab58fc8",
  null
  
)

export default component.exports